import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";

export function CaseStudies() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/case-studies").then((r) => setItems(r.data)); }, []);
  return (
    <div data-testid="case-studies-page" className="fade-in py-20">
      <div className="container-gos">
        <div className="overline mb-3">Stories</div>
        <h1 className="font-display text-4xl sm:text-5xl text-gos-charcoal tracking-tight">Case studies from across our network.</h1>
        <p className="text-gos-slate mt-4 max-w-2xl">Illustrative examples based on common client scenarios. Names changed to protect confidentiality.</p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-12">
          {items.map((cs) => (
            <Link to={`/case-studies/${cs.slug}`} key={cs.id} data-testid={`case-card-${cs.slug}`} className="card-lift bg-white border border-gos-border rounded-sm overflow-hidden">
              {cs.image_url && <img src={cs.image_url} alt={cs.title} className="aspect-[16/10] object-cover w-full" />}
              <div className="p-6">
                <div className="overline text-gos-sand mb-2">{cs.client_origin} → {cs.target_country}</div>
                <div className="font-display text-xl text-gos-navy leading-snug">{cs.title}</div>
                <p className="text-sm text-gos-slate mt-3 line-clamp-3">{cs.challenge}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

export function CaseStudyDetail() {
  const { slug } = useParams();
  const [cs, setCs] = useState(null);
  useEffect(() => { api.get(`/case-studies/${slug}`).then((r) => setCs(r.data)); }, [slug]);
  if (!cs) return <div className="py-32 text-center text-gos-muted">Loading…</div>;
  return (
    <div data-testid={`case-detail-${slug}`} className="fade-in py-20">
      <div className="container-gos max-w-4xl">
        <div className="overline text-gos-sand">{cs.client_origin} → {cs.target_country} · {cs.industry}</div>
        <h1 className="font-display text-4xl sm:text-5xl tracking-tight text-gos-charcoal mt-3">{cs.title}</h1>
        {cs.image_url && <img src={cs.image_url} alt={cs.title} className="w-full aspect-[16/9] object-cover mt-8 rounded-sm" />}

        <Section label="Challenge" content={cs.challenge} />
        <Section label="Solution" content={cs.solution} />
        <Section label="Outcome" content={cs.outcome} />

        <div className="mt-8">
          <div className="overline mb-3">Services used</div>
          <div className="flex flex-wrap gap-2">
            {cs.services_used.map((s) => (
              <span key={s} className="bg-gos-subtle border border-gos-border px-3 py-1 rounded-sm text-sm">{s}</span>
            ))}
          </div>
        </div>
        <p className="text-xs text-gos-muted mt-12">Illustrative example based on common client scenarios.</p>
      </div>
    </div>
  );
}

function Section({ label, content }) {
  return (
    <div className="mt-10">
      <div className="overline mb-3">{label}</div>
      <p className="text-base text-gos-slate leading-relaxed">{content}</p>
    </div>
  );
}
